module.exports = __webpack_public_path__ + "assets/life_icon_market_background2_.543be67f.svg";